


































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { getRules } from "@/services/admin/getRules";

import {
  IMain,
  IMainRoutes,
  IMainRoutesMethods,
} from "@/@types/servers/main-server";

@Component({})
export default class MainRules extends Vue {
  @Prop({ type: Array, default: [] }) allRules!: IMain[];
  @Prop({ type: Array, default: [] }) permissions!: string[];

  userRules: IMain[] = [];

  changeMainServerRule(serverName: string): void {
    for (let i = 0; i < this.userRules.length; i++) {
      if (this.userRules[i].name == serverName) {
        this.userRules.splice(i, 1);
        return;
      }
    }

    for (const server of this.allRules) {
      if (server.name == serverName) {
        const newServer: IMain = {
          name: server.name,
          locale: server.locale,
          port: server.port,
          routes: [],
        };
        this.userRules.push(newServer);
      }
    }
  }

  changeMainRoutesRule(serverName: string, routeName: string): void {
    for (const server of this.userRules) {
      if (server.name == serverName) {
        for (let i = 0; i < server.routes.length; i++) {
          if (server.routes[i].name == routeName) {
            server.routes.splice(i, 1);
            return;
          }
        }
      }
    }

    for (const server of this.allRules) {
      if (server.name == serverName) {
        for (const route of server.routes) {
          if (route.name == routeName) {
            const newRoute: IMainRoutes = {
              name: route.name,
              locale: route.locale,
              methods: [],
            };
            for (const serverRules of this.userRules) {
              if (serverRules.name == serverName) {
                serverRules.routes.push(newRoute);
              }
            }
          }
        }
      }
    }
  }

  changeMainMethodsRule(
    serverName: string,
    routeName: string,
    methodsName: string
  ): void {
    for (const server of this.userRules) {
      if (server.name == serverName) {
        for (const route of server.routes) {
          if (route.name == routeName) {
            for (let i = 0; i < route.methods.length; i++) {
              if (route.methods[i].id == methodsName) {
                route.methods.splice(i, 1);
                return;
              }
            }
          }
        }
      }
    }

    for (const server of this.allRules) {
      if (server.name == serverName) {
        for (const route of server.routes) {
          if (route.name == routeName) {
            for (const method of route.methods) {
              if (method.id == methodsName) {
                const newMethod: IMainRoutesMethods = {
                  type: method.type,
                  id: method.id.slice(),
                  name: method.name.slice(),
                  locale: method.locale,
                  entry_point: method.entry_point,
                };
                for (const serverRules of this.userRules) {
                  if (serverRules.name == serverName) {
                    for (const routeRules of serverRules.routes) {
                      if (routeRules.name == routeName) {
                        routeRules.methods.push(newMethod);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  getServerChecked(serverName: string): boolean {
    for (const server of this.userRules) {
      if (server.name == serverName) return true;
    }
    return false;
  }

  getRoutesChecked(routeName: string): boolean {
    for (const server of this.userRules) {
      for (const route of server.routes) {
        if (route.name === routeName) return true;
      }
    }
    return false;
  }

  getMethodsChecked(methodsName: string): boolean {
    for (const server of this.userRules) {
      for (const route of server.routes) {
        for (const method of route.methods) {
          if (method.id == methodsName) return true;
        }
      }
    }

    return false;
  }

  @Watch("userRules", { deep: true })
  updateUserRules(): void {
    this.$emit("updateUserRules", this.userRules);
  }

  async createUserRulesArray(): Promise<void> {
    this.userRules = await getRules(
      JSON.parse(JSON.stringify(this.allRules)),
      this.permissions
    );
  }
  mounted(): void {
    if (this.permissions.length) {
      this.createUserRulesArray();
    }
  }
}
